export const phonePrefixes = [
  {
    text: 'Zain',
    value: '+96279',
  },
  {
    text: 'Orange',
    value: '+96277',
  },
  {
    text: 'Uminh',
    value: '+96278',
  },
]
export const devices = [
  {
    text: 'Huawei',
    value: 'huawei',
  },
  {
    text: 'Android',
    value: 'android',
  },
  {
    text: 'IOS',
    value: 'ios',
  },
]
export const rateOptions = [
  {
    text: 'Percentage',
    value: 'percentage',
  },
  {
    text: 'Fixed',
    value: 'fixed',
  },
]
